"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentBrowserLanguage = getCurrentBrowserLanguage;
var _shared = require("@ori-appshell/shared");
function getCurrentBrowserLanguage() {
  if (typeof window === 'undefined') {
    return _shared.DEFAULT_LANGUAGE;
  }
  const documentLanguage = window.document.documentElement.lang;
  const clientLanguage = String(navigator.language || '');
  const fallbackLanguage = _shared.DEFAULT_LANGUAGE;
  if (clientLanguage.length >= 2) {
    return clientLanguage.slice(0, 2);
  } else if (clientLanguage.length === 2) {
    return clientLanguage;
  }
  return documentLanguage || clientLanguage || fallbackLanguage;
}
